import { loadView } from '@/router'

export default [
  {
    path: '/dashboards',
    name: 'dashboards',
    component: loadView('Dashboards'),
    redirect: {
      name: 'dashboards-dashboard'
    },
    children: [
      {
        path: ':accountId',
        name: 'dashboards-dashboard',
        component: loadView('Dashboards/Dashboard')
      }
    ]
  }
]
